import { checkElementInView } from 'propel/checkElementInView';

const mainElement = document.getElementById('main');
let topObserver = null;
let heroObserver = null;
let previousWidth = window.innerWidth;

const atTop = () => {
	document.body.classList.remove('scrolled');
};

const notAtTop = () => {
	document.body.classList.add('scrolled');
};

const pastHero = () => {
	document.body.classList.add('past-hero');
};

const notPastHero = () => {
	document.body.classList.remove('past-hero');
};

const sectionsInView = () => {
	if (!topObserver) {
		topObserver = checkElementInView('#top', atTop, notAtTop, {
			root: null,
			rootMargin: '0px 0px 0px 0px',
			threshold: [1],
		});
	}

	if (mainElement?.firstElementChild) {
		if (heroObserver) {
			if (
				(previousWidth >= 992 && window.innerWidth < 992) ||
				(previousWidth < 992 && window.innerWidth >= 992)
			) {
				previousWidth = window.innerWidth;

				return;
			}

			heroObserver.disconnect();
		}

		const headerHeight =
			document.body.style.getPropertyValue('--header-height');

		const rem =
			parseFloat(getComputedStyle(document.documentElement).fontSize) ||
			16;
		const headerHeightPx = parseFloat(headerHeight) * rem + 2;

		heroObserver = checkElementInView(
			mainElement.firstElementChild,
			notPastHero,
			pastHero,
			{
				root: null,
				rootMargin: `-${headerHeightPx}px 0px 0px 0px`,
				threshold: [0],
			}
		);
	}

	previousWidth = window.innerWidth;
};

export default sectionsInView;
